import React from 'react';
import './SignatureLoader.css';

const SignatureLoader = () => (
  <div className="signature-loader">
    <svg width="200" height="100" viewBox="0 0 200 100">
      {/* Ruta que simula una firma; puedes modificarla según tu gusto */}
      <path
        className="signature-path"
        d="M10,50 C40,10 60,90 90,50 S140,90 170,50"
        fill="none"
        stroke="#1F2937"
        strokeWidth="2"
      />
    </svg>
  </div>
);

export default SignatureLoader;
